import { type PropsWithChildren } from 'react';
import { BodyText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesTitle = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <BodyText sizeMatch={['16']} bold>
      {children}
    </BodyText>
  );
};
